import { FormYesNoQuestion } from '~/components/FormComponents/FormYesNoQuestion';
import { Box, Typography } from '@mui/material';
import { PremisesTypesCheckboxGroup } from './PremisesTypesCheckboxGroup';
import { useFormContext } from 'react-hook-form';
import { TPurposeOfBusinessRelations } from '../../types';
import useGetContragentTypes from '~/modules/identification/hooks/useGetContragentTypes';

interface IConflictTeretoriesProps {
  premisesInConflictZoneText: string;
}

export const ConflictTeretories = ({ premisesInConflictZoneText }: IConflictTeretoriesProps) => {
  const { watch, setValue } = useFormContext<TPurposeOfBusinessRelations>();
  const { isLegalResident } = useGetContragentTypes();

  const isPremisesInConflictZone = watch('isPremisesInConflictZone');
  const showAdditionalOptions = isPremisesInConflictZone && isLegalResident;

  const handleIsPremisesInConflictZone = (isChecked: boolean) => {
    if (isLegalResident) {
      const value = isChecked ? null : false;
      setValue('arePremisesUsedInWarZones', value);
      setValue('isIncomeReceivedFromWarZones', value);
      setValue('isEmployeesReceiveSalary', value);
      setValue('isReRegistrationAgreed', value);
      setValue('premisesTypesInConflictZone', []);
    }
  };

  return (
    <>
      <FormYesNoQuestion
        question={premisesInConflictZoneText}
        name="isPremisesInConflictZone"
        onChange={handleIsPremisesInConflictZone}
      />
      {showAdditionalOptions && (
        <>
          <Box sx={{ width: '100%' }}>
            <Typography variant="body2">
              Оберіть які саме приміщення розташовані на територіях, на яких ведуться активні бойові
              дії або які є ТОТ?
            </Typography>
            <PremisesTypesCheckboxGroup />
          </Box>
          <FormYesNoQuestion
            question={
              'Чи використовуєте Ви наявні приміщення на територіях, на яких ведуться активні бойові дії або які є ТОТ?'
            }
            name="arePremisesUsedInWarZones"
          />
          <FormYesNoQuestion
            question={
              'Чи отримуєте Ви дохід з наявних приміщень на територіях, на яких ведуться активні бойові дії або які є ТОТ?'
            }
            name="isIncomeReceivedFromWarZones"
          />
          <FormYesNoQuestion
            question={
              'Чи виплачуєте Ви найманим працівникам, які знаходиться на територіях, на яких ведуться активні бойові дії або які є ТОТ, заробітну плату?'
            }
            name="isEmployeesReceiveSalary"
          />
          <FormYesNoQuestion
            question={
              'Якщо Ваша юридична особа перереєстрована в період дії воєнного стану за законодавством російської федерації, чи брали Ви участь/надавали згоду на її перереєстрацію?'
            }
            name="isReRegistrationAgreed"
          />
        </>
      )}
    </>
  );
};
